import {
  DocumentationAnalyticsByCategorySortInputObject,
  SortDirectionEnum,
} from 'graphql-common';
import {
  ORDERING_DIRECTION_ASC,
  ORDERING_DIRECTION_DESC,
} from '@lib/enums/urls';

const sortableFields = new Set(['categoryName', 'viewCount', 'percentage']);

export default function getCategorySorts(
  orderingField?: string | null,
  orderingDirection?: string | null,
): DocumentationAnalyticsByCategorySortInputObject | undefined {
  if (!orderingField || !sortableFields.has(orderingField)) return undefined;
  let direction: SortDirectionEnum;
  if (orderingDirection === ORDERING_DIRECTION_ASC) {
    direction = SortDirectionEnum.Asc;
  } else if (orderingDirection === ORDERING_DIRECTION_DESC) {
    direction = SortDirectionEnum.Desc;
  } else {
    return undefined;
  }
  return {
    [orderingField]: direction,
  } as DocumentationAnalyticsByCategorySortInputObject;
}
